import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ResetPasswordFailIcon } from '~/img';
import PasswordResetLayout from '~/layout/PasswordResetLayout';
import { useIdentity } from '~/hooks/identity';
import { useResetOnboardingState, useSkipSteps } from '~/hooks/onboarding';
import { onboarding } from '~/routes';

const NoBusinessProfile: FC<RouteComponentProps> = () => {
  const { t } = useTranslation('noBusinessProfile');

  const setOnboardingInitialValues = useResetOnboardingState(); // init onboarding redux state with initialState
  const skipHandlers = useSkipSteps();
  const history = useHistory();
  const identityQuery = useIdentity();
  const identityName = identityQuery.data?.name || identityQuery.data?.username || 'Unknown User';

  const [isLoading, setLoading] = useState(false);
  const onClick = () => {
    if (identityQuery.data) {
      setLoading(true);
      setOnboardingInitialValues();

      skipHandlers.authenticate(true);
      skipHandlers.phoneNumber(true);
      skipHandlers.password(true);
      //
      if (identityQuery.data.emailAddress) {
        skipHandlers.email(true);
      }
      history.push(`/${onboarding}`);
      setLoading(false);
    }
  };

  return (
    <PasswordResetLayout
      icon={<ResetPasswordFailIcon />}
      title={t('Hello, {{name}}!', { name: identityName })}
      subtitle={t(
        'Sorry, we cannot find your business profile. Please complete the onboarding to log in.'
      )}
      withGoToLogin
    >
      <Button
        type="primary"
        size="large"
        onClick={onClick}
        loading={isLoading || identityQuery.isLoading}
        disabled={!identityQuery.data}
      >
        {t('Proceed')}
      </Button>
    </PasswordResetLayout>
  );
};

export default NoBusinessProfile;
